import React, { Component } from "react";
import {
    Button,

    Col,
    message,
    Form,
    Input,
    Row,
    Select,
    Upload,

    Modal,
    Spin,
    Space,

    Tabs,
} from "antd";
import { CloseOutlined, UploadOutlined } from "@ant-design/icons";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import VehicleTitleBox from "./VehicleTitleBox";
import PassengersStore from "../store/PassengerStore";
import withRouter1 from "../withRouter";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";

import CompanyStore from "../store/CompanyStore";
import Autocomplete from "react-google-autocomplete";
import config from "../config";
import conf from "../config";
import "leaflet/dist/leaflet.css";
import DisplayLocationMap from "./DisplayLocationMap";
import dayjs from "dayjs";
import CountryStore from "../store/CountryStore";

import axios from "axios";
import Cookies from "universal-cookie";
import { decode as base64_decode, } from "base-64";

import StudentStore from "../store/StudentStore";
import StudentRouteStore from "../store/StudentRouteStore";

const { Option } = Select;
const { TabPane } = Tabs;
class StudentAdd extends Component {
    formRef = React.createRef();
    constructor(prop) {
        super(prop);
        this.state = {
            activeTab: "1",
            tabErrors: {},
            formError: false,
            loading: false,
            passengerId: -1,
            stId: null,
            getVehicles: [],
            companyId: "",
            employeeType: false,
            studentType: true,
            type: "Student",
            loadingData: false,
            arealist: [],
            busRootShow: false,
            currentPage: "",
            pageSize: "",
            addressMapPickup: false,
            addressMapDropoff: false,
            // addressInfoPickup: [], 
            addressInfoPickup: config.mapCenter,
            // addressInfoDropoff: [],
            addressInfoDropoff: config.mapCenter,
            update: 0,
            photo: "",
            loadingSpin: false,
            token: "",
            pickupLatLng: "",
            dropoffLatLng: "",

            photo1: "",
            photo2: "",
            tagIdError: false,
            searchTypePick: "location",
            passengerStatus: null

        };
        this.passengerStore = new PassengersStore(this);
        this.vehicleStore = new VehicleStore(this);
        this.companyStore = new CompanyStore(this);
        this.studentStore = new StudentStore(this);

        this.studentRouteStore = new StudentRouteStore(this);

        this.cookies = new Cookies();
        // this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.query = new URLSearchParams(this.props.location.search);
        this.queryId = this.query.get("schollPassenger");
        this.mapRef = React.createRef();
        // console.log(query.get("schollPassenger"))
        this.countryStore = new CountryStore(this);
    }
    AreaLoad = async () => {
        const arealist = await this.studentRouteStore.getArea();
        // console.log(arealist, "arealist");
        await this.setState({ arealist: arealist, update: 1 });
    }

    async componentDidMount() {
        this.AreaLoad();
        await this.countryStore.getCountry();

        await this.studentStore.getPassengerStatus()
        let tokendata = this.cookies.get("data")
            ? JSON.parse(base64_decode(this.cookies.get("data")))
            : "";
        const userToken = tokendata.userToken;

        this.setState({ token: userToken });

        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            // await this.studentStore.getVehicles({ companyId: this.props.getUserData().userCompanyId, isadmin: this.props.getUserData().isadmin, userId: this.props.getUserData().userId });
            await this.studentStore.getVehicles(this.props.getUserData().userCompanyId);
            await this.studentStore.getSchooltrip(this.props.getUserData().userCompanyId);
            this.context.viewStateStore.setStudentDetails({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            // await this.passengerStore.getBusNo(
            //     this.props.getUserData().userCompanyId
            // );
        }
        const passengerId = this.props.passengerId;


        if (passengerId) {
            this.filldata(passengerId);
        }
        // this.passengerStore.getAddress()



        const data = await this.studentStore.getAllClass();
        console.log(data);

        await this.setState({ loadList: 1 });
    }
    filldata = async (passengerId) => {
        await this.setState({ loadingSpin: true });
        const getPassengerData = await this.studentStore.getStudentData(
            passengerId
        );
        await this.studentStore.getVehicles(getPassengerData.companyId);

        // await this.passengerStore.getBusNo(getPassengerData.companyId);
        await this.setState({
            companyId: getPassengerData.companyId,
            passengerId: getPassengerData.passengerId,
            stId: getPassengerData.stId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
            getPassengerData.companyId
        );
        // this.handlePlaceSelectedpickup(getPassengerData.pickUpPoint);
        // this.handlePlaceSelecteddrop(getPassengerData.dropPoint);

        await this.passengerStore.getAllClass();
        const termValue = getPassengerData.term;
        await this.formRef.current.setFieldsValue({
            studentName: getPassengerData.studentName,
            passengerId: getPassengerData.passengerId,
            companyId: singleData,
            vehicleNo: getPassengerData.vehicleId,
            idNo: getPassengerData.idNo,
            mobileNo: getPassengerData.mobileNo,
            tagId: getPassengerData.tagId,
            className: getPassengerData.classId,
            schoolName: getPassengerData.schoolName,
            type: getPassengerData.type,
            service: getPassengerData.service,
            term: termValue ? termValue.split(",").map(Number) : [],
            transportation: getPassengerData.transportation,
            gender: Number(getPassengerData.gender),
            vehicleType: getPassengerData.vehicleType,
            dropOffTime: getPassengerData.dropOffTime
                ? dayjs(getPassengerData.dropOffTime, "HH:mm")
                : "",
            pickUpTime: getPassengerData.pickUpTime
                ? dayjs(getPassengerData.pickUpTime, "HH:mm")
                : "",
            dropPoint: getPassengerData.dropPoint,
            pickUpPoint: getPassengerData.pickUpPoint,
            pickupLat: getPassengerData.pickupLat,
            pickupLng: getPassengerData.pickupLong,
            dropoffLat: getPassengerData.dropLat,
            dropoffLng: getPassengerData.dropLong,
            classDiv: getPassengerData.classDiv,
            guardianContactNo: getPassengerData.guardianContactNo,
            guardianName: getPassengerData.guardianName,
            motherContactNo: getPassengerData.motherContactNo,
            motherName: getPassengerData.motherName,
            fatherContactNo: getPassengerData.fatherContactNo,
            fatherName: getPassengerData.fatherName,
            transportationType: getPassengerData.transportationType,
            stId: getPassengerData.stId,
            countryCode: getPassengerData.countryCode,
            fatherContactNoCountryCode: getPassengerData.fatherContactNoCountryCode,
            motherContactNoCountryCode: getPassengerData.motherContactNoCountryCode,
            guardianContactNoCountryCode: getPassengerData.guardianContactNoCountryCode,
            pickupBusId: getPassengerData.pickupVehicleId,
            dropBusId: getPassengerData.dropVehicleId,
            fatherWhatsAppNo: getPassengerData.fatherWhatsAppNo,
            fatherEmail: getPassengerData.fatherEmail,
            motherWhatsAppNo: getPassengerData.motherWhatsAppNo,
            gardianWhatsAppNo: getPassengerData.gardianWhatsAppNo,
            fatherWhatsAppNoCountryCode: getPassengerData.fatherWhatsAppNoCountryCode,
            motherWhatsAppNoCountryCode: getPassengerData.motherWhatsAppNoCountryCode,
            guardianWhatsAppNoCountryCode: getPassengerData.guardianWhatsAppNoCountryCode,
            gardianEmail: getPassengerData.gardianEmail,
            motherEmail: getPassengerData.motherEmail,
            primaryEmail: getPassengerData.primaryEmail,
            pRouteName: getPassengerData.pRouteName,
            dRouteName: getPassengerData.dRouteName,
            dTripName: getPassengerData.dTripName,
            pTripName: getPassengerData.pTripName,
            pickUpArea: getPassengerData.pickUpArea
                ? Number(getPassengerData.pickUpArea.split(',')[0])
                : undefined,
            dropOffArea: getPassengerData.dropOffArea
                ? Number(getPassengerData.dropOffArea.split(',')[0])
                : undefined,
            photo: getPassengerData.photo,
            passengerStatusId: getPassengerData.passengerStatusId
        });
        this.setState({
            photo: getPassengerData.photo, photo1: getPassengerData.parentPhoto1,
            photo2: getPassengerData.parentPhoto2,
            addressInfoPickup: [
                Number(getPassengerData?.pickupLat),
                Number(getPassengerData?.pickupLong)
            ],
            addressInfoDropoff: [
                Number(getPassengerData?.dropLat),
                Number(getPassengerData?.dropLong)
            ],
        });

        await this.setState({ loadingSpin: false });
    };

    async handleChange(comp) {
        const getVehicles = await this.studentStore.getVehicles(comp.value);
        const schooltripList = await this.studentStore.getSchooltrip(comp.value);

        console.log(getVehicles);

        await this.setState({ companyId: comp.value });
        this.context.viewStateStore.setStudentDetails({
            companyId: comp.value
        });
        console.log(this.state.companyId);
        this.formRef.current.setFieldsValue({ companyId: comp.value });
        if (!this.props.passengerIdEdit) {
            console.log("inn");
            this.context.viewStateStore.setPassengerStates({ companyId: comp.value });
        }
        await this.setState({ loadList: 1 });

        // await this.handleSearch();
    }

    async handleSearch() {
        await this.passengerStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId,
        });

        await this.setState({ loadList: 1 });
    }

    onFinish = async (fieldsValue) => {

        this.setState({ loading: true });
        console.log("**********fieldsValue********************", fieldsValue);
        const data = {
            ...fieldsValue,
            companyId: this.state.companyId,
            passengerId: this.state.passengerId,
            photo: this.state.photo,
            parentPhoto1: this.state.photo1,
            parentPhoto2: this.state.photo2,
            stId: this.state.stId,
            pickUpTime: fieldsValue?.pickUpTime
                ? fieldsValue?.pickUpTime?.format("HH:mm")
                : "",
            dropOffTime: fieldsValue?.dropOffTime
                ? fieldsValue?.dropOffTime?.format("HH:mm")
                : "",
            dropVehicleId: fieldsValue?.dropBusId,
            pickupVehicleId: fieldsValue?.pickupBusId,
            vehicleIds: [fieldsValue?.pickupBusId, fieldsValue?.dropBusId],
            type: "Student",
            pickupLat: fieldsValue?.pickupLat,//this.state.pickupLatLng?.lat,
            pickupLong: fieldsValue?.pickupLng,//this.state.pickupLatLng?.lng,
            dropLat: fieldsValue?.dropoffLat,//this.state.dropoffLatLng?.lat,
            dropLong: fieldsValue?.dropoffLng,//this.state.dropoffLatLng?.lng
            passengerStatusId: this.state.passengerStatus

        };
        // debugger
        console.log("***************data*********************", data);
        // await this.props.response(data);

        const response = await this.studentStore.addData(data);
        // debugger
        console.log(response, "res");
        // if (response?.success === "S") {
        //     await this.props.closeModal();
        //     message.success(response?.message);
        await this.props.response(response);
        if (
            this.context.translate(response?.errors[0]?.tagId) ===
            "Tag Id is already in use.Please try different Tag Id."
        ) {
            this.setState({
                activeTab: '1',
            });
            this.setState({
                tagIdError: (
                    <div style={{ marginTop: 5, color: "red", fontSize: 12 }}>
                        Tag Id is already in use.Please try different Tag Id.
                    </div>
                ),
            });
        }
        // } else {
        //     message.error(response?.message);
        //     // message.error(response?.errors[0].tagId);

        // }


        this.setState({ loading: false });
    };

    fillClassDiv = () => {
        var div = [];

        for (let i = 65; i <= 77; i++) {
            div.push(String.fromCharCode(i));
        }
        if (div) {
            return div.map((value) => {
                return (
                    <Select.Option key={value} value={value}>
                        {value}
                    </Select.Option>
                );
            });
        }
    };

    onTypeChange = (val) => {
        if (val === "Student") {
            this.setState({ studentType: true });
            this.setState({ employeeType: false });
        } else {
            this.setState({ studentType: false });
            this.setState({ employeeType: true });
        }
    };
    validateNumber = (value, field1) => {
        // Check if value contains only numbers
        const isValid = /^[0-9]+$/.test(value);
        const value1 = value.replace(/[^0-9+]*/g, "");
        if (value1.length > 0) {
            this.formRef.current.setFieldsValue({ [field1]: value1 });
        } else {
            this.formRef.current.setFieldsValue({ [field1]: "" });
        }
    };
    validateFee = (value, field1) => {
        // Check if value contains only numbers
        const isValid = /^[0-9.]+$/.test(value);
        const value1 = value.replace(/[^0-9.]*/g, "");
        console.log(value1.length);
        if (value1.length > 0) {
            this.formRef.current.setFieldsValue({ [field1]: value1 });
        } else {
            this.formRef.current.setFieldsValue({ [field1]: "" });
        }
    };

    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        this.handleSearch();
    }

    getUploadData = async (fileUp, filetype) => {
        let fileinfo = fileUp.file.response;
        if (fileinfo?.success == "S") {
            fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
            if (filetype == "studentphoto") {
                this.setState({ photo: fileinfo.data });
                this.studentStore.setPhotoFromDbstud(fileUp.fileList);

            }
            if (filetype == "parentphoto1") {
                this.setState({ photo1: fileinfo.data });
                this.studentStore.setPhotoFromDbparent1(fileUp.fileList);

            }
            if (filetype == "parentphoto2") {
                this.setState({ photo2: fileinfo.data });
                this.studentStore.setPhotoFromDbparent2(fileUp.fileList);
            }
            // await this.setState({ photo: fileinfo.data });
        }
        this.setState({ update: 1 });
    };

    validateFile = (file) => {
        this.setState({ fileList: file });
        console.log(file);
        const allowedExtensions = [".jpeg", ".jpg", ".png"];
        const fileName = file.name;
        const fileExtension = fileName.slice(
            ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
        );
        if (!allowedExtensions.includes("." + fileExtension.toLowerCase())) {
            message.error("Only JPEG and PNG files are allowed");
            return false;
        }
        const maxSize = conf.photoUploadSize;
        if (file.size > maxSize) {
            message.error(this.context.translate("_FILE_SIZE_UPTO_10_MB"));
            return false;
        }
        return true;
    };

    closeModal = () => {
        this.props.closeModal();
    };
    uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
        try {
            const formData = new FormData();
            formData.append("photo", file);
            formData.append("fileType", "passengerimport");
            formData.append("fieldName", "photo");

            const response = await axios.post(
                // config.baseURL + this.companyStore.fileUploadUrl,
                config.NodeUrl + "/employee/fileUpload",
                formData,
                {
                    headers: {
                        token: this.state.token,
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (event) => {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        onProgress({ percent });
                    },
                }
            );

            onSuccess(response.data);
        } catch (error) {
            onError(error);
        }
    };
    handleNextClick = async () => {
        const form = this.formRef.current;

        if (form) {
            try {
                if (this.state.activeTab === "1") {
                    // Validate only the fields in the 'User Information' tab
                    await form.validateFields([
                        'companyId',
                        'className',
                        'gender',
                        'idNo',
                        'studentName',
                    ]);
                } else {
                    // Validate all fields in other tabs
                    await form.validateFields();
                }

                const { activeTab } = this.state;
                let nextTab = String(Number(activeTab) + 1);
                // if (this.props.getUserData()?.isadmin == -1) {
                //   nextTab = String(Number(activeTab) + 1);
                // } else
                if (this.props.studentId) {
                    nextTab = String(
                        Number(activeTab) === 1
                            ? Number(activeTab) + 2
                            : Number(activeTab) + 1
                    );
                }

                this.setState({ activeTab: nextTab });
            } catch (err) {
                console.error("Form Validation Error:", err);
                message.error(
                    this.context.translate("_FLEET_VEHICLE_VEHICLEDETAIL_ERRORMSG_")
                    // "Please fill correct data in the fields that are marked red."
                );
                this.setState({ formError: true });
            }
        }
    };

    handleFormError = (err) => {
        console.log(err);
        const { errorFields } = err;

        const tabErrors = {};

        errorFields.forEach(({ name }) => {
            const [fieldName] = name;
            const tabFieldMappings = {
                companyId: 1,
                className: 1,
                gender: 1,
                idNo: 1,
                studentName: 1,

            };
            const tab = tabFieldMappings[fieldName];
            console.warn(tab);
            if (tab) {
                tabErrors[tab] = true;
            }
        });

        this.setState({ tabErrors }); // Update the state with tabErrors
    };

    handleBackClick = () => {
        const { activeTab } = this.state;
        let previousTab = String(Number(activeTab) - 1);

        if (this.props.studentId) {
            previousTab = String(
                Number(activeTab) === 3 ? Number(activeTab) - 2 : Number(activeTab) - 1
            );
        }
        this.setState({ activeTab: previousTab });
    };
    showTabTitle = () => {
        const { activeTab } = this.state;

        if (activeTab === "1") {
            return this.context.translate("_STUDENT_DETAILS_");
        } else if (activeTab === "2") {
            return this.context.translate("_PICKUP_DROP_TAB_TITLE_");
        } else if (activeTab === "3") {
            return this.context.translate("_CONTACT_DETAILS_");
        }
    };

    showTabDesc = () => {
        const { activeTab } = this.state;
        if (activeTab === "1") {
            return this.context.translate("_STUDENT_ADD_DESC_");
        } else if (activeTab === "2") {
            return this.context.translate("_PICKUP_DROP_TAB_DESC_");
        } else if (activeTab === "3") {
            return this.context.translate("_CONTACT_DETAILS_DESC_");
        }
    };
    // handlePlaceSelectedpickup = (place) => {
    //     if (!place.geometry) return;

    //     const lat = place.geometry.location.lat();
    //     const lng = place.geometry.location.lng();

    //     this.setState({
    //         addressMapPickup: true,
    //         addressInfoPickup: [lat, lng],
    //     });

    //     this.formRef.current.setFieldsValue({
    //         pickUpPoint: place.formatted_address
    //     });
    // };
    handlePlaceSelectedpickup = async (place) => {
        console.log("Pick up trip *****", place)
        await this.setState({ addressMapPickup: true });
        await this.setState({
            addressInfoPickup: [
                place.geometry.location.lat(),
                place.geometry.location.lng(),
            ],
        });

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        this.setState({
            pickupLatLng: { lat, lng }
        });

        // Optional: store address in form
        this.formRef.current.setFieldsValue({
            pickUpPoint: place.formatted_address,
            pickupLat: lat,
            pickupLng: lng
        });



    };
    handlePlaceSelecteddropoff = async (place) => {
        console.log("Drop off trip *****", place)

        await this.setState({ addressMapDropoff: true });
        await this.setState({
            addressInfoDropoff: [
                place.geometry.location.lat(),
                place.geometry.location.lng(),
            ],
        });

        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        this.setState({
            dropoffLatLng: { lat, lng },
            dropoffLat: lat,
            dropoffLng: lng

        });
        console.log("before", place.formatted_address)
        // Optional: store address in form
        this.formRef.current.setFieldsValue({
            dropPoint: place.formatted_address,
            dropoffLat: lat,
            dropoffLng: lng
        });

    };
    handleTabChange = (key) => {
        this.setState({
            activeTab: key,
            formError: false, // Reset formError when switching tabs
        });
    };


    uploadFunctionimg = async ({ file, onSuccess, onError, onProgress }) => {
        try {
            const formData = new FormData();
            formData.append("photo", file);
            formData.append("fileType", "passengerimport");
            formData.append("fieldName", "photo");

            console.log(this.state.token, "token");
            const response = await axios.post(
                // config.baseURL + this.companyStore.fileUploadUrl,
                config.NodeUrl + "/passenger/fileUpload",
                formData,
                {
                    headers: {
                        token: this.state.token,
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (event) => {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        onProgress({ percent });
                    },
                }
            );

            onSuccess(response.data);
        } catch (error) {
            onError(error);
        }
    };

    onExcelSubmit = async (fieldsValue) => {
        const data = {
            ...fieldsValue,
            companyId: this.state.companyId,
            excelFile: this.state.excelFile,
        };

        if (data.excelFile) {
            const resp = await this.passengerStore.addStudentByExcel(data);

            if (resp?.success == "S") {
                message.success(resp.message);
                this.setState({ excelFile: "" });
            } else {
                message.error(resp.errors[0].error);
            }
            if (resp.message) {
                this.setState({ showUpload: false });
                this.formRef.current?.resetFields();
            }
        } else {
            message.error("Please Upload Excel File");
        }
    };

    handlePlaceSelectedpickupCoordinates = async (coordinates) => {
        if (!coordinates) return;

        const parts = coordinates.split(",");

        if (parts.length !== 2) {
            message.error("Invalid format. Use: lat, lng");
            return;
        }

        const lat = parseFloat(parts[0].trim());
        const lng = parseFloat(parts[1].trim());

        if (
            isNaN(lat) || isNaN(lng) ||
            lat < -90 || lat > 90 ||
            lng < -180 || lng > 180
        ) {
            message.error("Invalid coordinates");
            return;
        }

        // ✅ Update map + state
        this.setState({
            addressMapPickup: true,
            addressInfoPickup: [lat, lng],
            pickupLatLng: { lat, lng }
        });

        const geocoder = await new window.google.maps.Geocoder();

        geocoder.geocode(
            { location: { lat, lng } },
            (results, status) => {
                if (status === "OK" && results[0]) {
                    const address = results[0].formatted_address;
                    console.log("place:", address);
                    // ✅ Set address in form
                    this.formRef.current.setFieldsValue({
                        pickUpPoint: address
                    });

                    console.log("Resolved Address:", address);
                } else {
                    console.warn("Geocoder failed:", status);
                    message.warning("Address not found for these coordinates");
                }
            }
        );
    };

    handlePlaceSelecteddropCoordinates = async (coordinates) => {
        if (!coordinates) return;

        const parts = coordinates.split(",");

        if (parts.length !== 2) {
            message.error("Invalid format. Use: lat, lng");
            return;
        }

        const lat = parseFloat(parts[0].trim());
        const lng = parseFloat(parts[1].trim());

        if (
            isNaN(lat) || isNaN(lng) ||
            lat < -90 || lat > 90 ||
            lng < -180 || lng > 180
        ) {
            message.error("Invalid coordinates");
            return;
        }


        this.setState({
            addressMapDropoff: true,
            addressInfoDropoff: [lat, lng],
            dropoffLatLng: { lat, lng }
        });
        const geocoder = await new window.google.maps.Geocoder();

        geocoder.geocode(
            { location: { lat, lng } },
            (results, status) => {
                if (status === "OK" && results[0]) {
                    const address = results[0].formatted_address;
                    console.log("place:", address);
                    // ✅ Set address in form
                    this.formRef.current.setFieldsValue({
                        dropOffPoint: address
                    });

                    console.log("Resolved Address:", address);
                } else {
                    console.warn("Geocoder failed:", status);
                    message.warning("Address not found for these coordinates");
                }
            }
        );
    };

    handleLatLngChangePickup = async () => {
        const lat = parseFloat(this.formRef.current.getFieldValue("pickupLat"));
        const lng = parseFloat(this.formRef.current.getFieldValue("pickupLng"));

        if (
            isNaN(lat) || isNaN(lng) ||
            lat < -90 || lat > 90 ||
            lng < -180 || lng > 180
        ) {
            message.error("Invalid coordinates");
            return;
        }

        this.setState({
            addressMapPickup: true,
            addressInfoPickup: [lat, lng],
            pickupLatLng: { lat, lng }
        });

        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode(
            { location: { lat, lng } },
            (results, status) => {
                if (status === "OK" && results[0]) {
                    const address = results[0].formatted_address;

                    // ✅ Autofill address
                    this.formRef.current.setFieldsValue({
                        pickUpPoint: address
                    });

                } else {
                    message.warning("Address not found");
                }
            }
        );
    };

    handleAddressChangePickup = (address) => {
        if (!address) return;

        const geocoder = new window.google.maps.Geocoder();
        // const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address }, (results, status) => {
            if (status === "OK" && results[0]) {
                const location = results[0].geometry.location;

                const lat = location.lat();
                const lng = location.lng();

                // ✅ Update form fields
                this.formRef.current.setFieldsValue({
                    pickupLat: lat,
                    pickupLng: lng
                });

                // ✅ Update map
                this.setState({
                    addressMapPickup: true,
                    addressInfoPickup: [lat, lng],
                    pickupLatLng: { lat, lng }
                });
            } else {
                message.error("Invalid address");
            }
        });
    };

    handleLatLngChangeDrop = async () => {
        const lat = parseFloat(this.formRef.current.getFieldValue("dropoffLat"));
        const lng = parseFloat(this.formRef.current.getFieldValue("dropoffLng"));

        if (
            isNaN(lat) || isNaN(lng) ||
            lat < -90 || lat > 90 ||
            lng < -180 || lng > 180
        ) {
            message.error("Invalid coordinates");
            return;
        }

        this.setState({
            addressMapDropoff: true,
            addressInfoDropoff: [lat, lng],
            dropoffLatLng: { lat, lng }
        });

        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode(
            { location: { lat, lng } },
            (results, status) => {
                if (status === "OK" && results[0]) {
                    const address = results[0].formatted_address;

                    // ✅ Autofill address
                    this.formRef.current.setFieldsValue({
                        dropPoint: address
                    });

                } else {
                    message.warning("Address not found");
                }
            }
        );
    };

    handleAddressChangeDrop = (address) => {
        if (!address) return;

        const geocoder = new window.google.maps.Geocoder();
        // const geocoder = new google.maps.Geocoder();

        geocoder.geocode({ address }, (results, status) => {
            if (status === "OK" && results[0]) {
                const location = results[0].geometry.location;

                const lat = location.lat();
                const lng = location.lng();

                // ✅ Update form fields
                this.formRef.current.setFieldsValue({
                    dropoffLat: lat,
                    dropoffLng: lng
                });

                // ✅ Update map
                this.setState({
                    addressMapDropoff: true,
                    addressInfoDropoff: [lat, lng],
                    dropoffLatLng: { lat, lng }
                });
            } else {
                message.error("Invalid address");
            }
        });
    };
    render() {
        return (
            <>
                <div style={{ padding: 0, height: "100%" }}>
                    <div style={{ height: "100%" }}>
                        <Spin
                            spinning={this.state.loadingSpin}
                            wrapperClassName="spinClass"
                            fullscreen
                        >
                            <Form
                                ref={this.formRef}
                                labelCol={{
                                    span: 20,
                                }}
                                layout="vertical"
                                onFinish={this.onFinish}
                                onFinishFailed={this.handleFormError}
                                className="accountFormClass"
                                name="nest-message"
                            >
                                <div style={{ height: "100%" }}>
                                    <div
                                        style={{
                                            background: "#07163D",
                                            padding: "15px",
                                            height: "10%",
                                        }}
                                    >
                                        <h3 className="tab-title">{this.showTabTitle()}</h3>
                                        <p className="tab-description">{this.showTabDesc()}</p>
                                    </div>
                                    <Tabs
                                        className="accountTabs"
                                        style={{ height: "90%" }}
                                        activeKey={this.state.activeTab}
                                        onChange={this.handleTabChange}
                                    >
                                        <TabPane
                                            tab={
                                                <span
                                                    className={
                                                        this.state.tabErrors["1"] && "validation-failed"
                                                    }
                                                >
                                                    <Button
                                                        type="text"
                                                        style={{
                                                            background:
                                                                this.state.activeTab === "1"
                                                                    ? " rgba(255, 255, 255, 0.30)"
                                                                    : "rgb(7, 22, 61)",
                                                            border: "none",
                                                            borderRadius: "0px",
                                                        }}
                                                    >
                                                        {this.context.translate(
                                                            "_STUDENT_DETAILS_"
                                                        )}
                                                    </Button>
                                                </span>
                                            }
                                            key="1"
                                        >
                                            <div
                                                style={{
                                                    overflowY: "scroll",
                                                    height: "90%",
                                                    paddingInlineStart: "20px",
                                                }}
                                            ><VehicleTitleBox title={this.context.translate("")}>
                                                    <Row
                                                        gutter={16}
                                                    >
                                                        <Col span={12} className="formColumnClass">
                                                            {/* company */}
                                                            {(this.props.getUserData().isadmin === -1 ||
                                                                this.props.getUserData().isadmin === 3) && (
                                                                    <Form.Item
                                                                        name="companyId"
                                                                        // label="Account"
                                                                        className="uploadCompany"
                                                                        required={false}
                                                                        label={
                                                                            <span>
                                                                                {this.context.translate(
                                                                                    "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                                                                                )}{" "}
                                                                                <span style={{ color: "red" }}>*</span>
                                                                            </span>
                                                                        }
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: `${this.context.translate(
                                                                                    "_ACCOUNT_"
                                                                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <CompanyAutocomplete
                                                                            allowClear={true}
                                                                            onChange={this.handleChange}
                                                                            style={{ width: "100%" }}
                                                                        />
                                                                    </Form.Item>
                                                                )}
                                                            {/* student name */}
                                                            <Form.Item
                                                                name="studentName"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_STUDENT_NAME_"
                                                                        )}{" "}
                                                                        <span style={{ color: "red" }}>*</span>
                                                                    </span>
                                                                }
                                                                required={false}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: `${this.context.translate(
                                                                            "_STUDENT_NAME_"
                                                                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                                    },
                                                                ]}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                            {/* transport type */}
                                                            <Form.Item
                                                                className="uploadCompany"
                                                                name="transportationType"
                                                                // initialValue={1}
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_TRANSPORT_TYPE_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Select
                                                                    options={[
                                                                        { label: "Bus Transport", value: "Bus Transport" },
                                                                        { label: "Own Transport", value: "Own Transport" },
                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                            {/* term */}
                                                            <Form.Item
                                                                className="uploadCompany"
                                                                name="term"
                                                                // initialValue={1}
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_TERM_"
                                                                        )}{" "}
                                                                    </span>
                                                                }

                                                            >
                                                                <Select
                                                                    mode="multiple"
                                                                    allowClear
                                                                    options={[
                                                                        { label: "All", value: 'All' },
                                                                        { label: "First", value: 1 },
                                                                        { label: "Second", value: 2 },
                                                                        { label: "Third", value: 3 },
                                                                        // { label: "4", value: 4 },
                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                            {/*tag id */}
                                                            <Form.Item
                                                                name="tagId"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_TAG_ID_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                                help={
                                                                    this.state.tagIdError
                                                                        ? this.state.tagIdError
                                                                        : null
                                                                }
                                                            >
                                                                <Input
                                                                    status={
                                                                        this.state.tagIdError ? "error" : null
                                                                    }
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;

                                                                        if (this.state.tagIdError) {
                                                                            this.setState({ tagIdError: null });
                                                                        }


                                                                    }}
                                                                />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name="passengerStatusId"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_FLEET_DASHBORD_SETTING_STATUS_"
                                                                        )}{" "}
                                                                        <span style={{ color: "red" }}>*</span>
                                                                    </span>
                                                                }
                                                                required={false}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: `${this.context.translate(
                                                                            "_FLEET_DASHBORD_SETTING_STATUS_"
                                                                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    // style={{ width: 120 }}
                                                                    // className="searchInput"
                                                                    showSearch={{ optionFilterProp: 'label' }}
                                                                    placeholder="Status"
                                                                    onChange={async (value) => { await this.setState({ passengerStatus: value }); }}

                                                                    filterOption={(inputValue, option) => {
                                                                        if (option.children) {
                                                                            return (
                                                                                option.children
                                                                                    .toLowerCase()
                                                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                                                            );
                                                                        }
                                                                    }}
                                                                >  {this.studentStore.passengerStatusData?.map((val) => {
                                                                    return (
                                                                        <Option key={val.id} value={val.id}>{val.passengerStatus}</Option>
                                                                    );
                                                                })}

                                                                </Select>
                                                            </Form.Item>

                                                        </Col>

                                                        <Col span={12} className="formColumnClass">
                                                            {/* className */}
                                                            <Form.Item
                                                                className="uploadCompany"
                                                                name="className"
                                                                required={false}
                                                                label={
                                                                    <span>
                                                                        {this.context.translate("_CLASS_NAME_")}{" "}
                                                                        <span style={{ color: "red" }}>*</span>
                                                                    </span>
                                                                }
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: `${this.context.translate(
                                                                            "_CLASS_NAME_"
                                                                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    fieldNames={{
                                                                        value: "classId",
                                                                        label: "className",
                                                                    }}
                                                                    optionFilterProp="children"
                                                                    options={this.studentStore?.getClass}
                                                                />
                                                            </Form.Item>
                                                            {/* division */}
                                                            <Form.Item
                                                                className="uploadCompany"
                                                                name="classDiv"
                                                                // initialValue={1}
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_DIVISION_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Select
                                                                    options={[
                                                                        { label: "A", value: "A" },
                                                                        { label: "B", value: "B" },
                                                                        { label: "C", value: "C" },
                                                                        { label: "D", value: "D" },
                                                                        { label: "E", value: "E" },
                                                                        { label: "F", value: "F" },
                                                                        { label: "G", value: "G" },
                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                            {/* service */}
                                                            <Form.Item
                                                                className="uploadCompany"
                                                                name="service"
                                                                // initialValue={1}
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_SERVICE_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Select
                                                                    options={[
                                                                        { label: "Pick", value: "Pick" },
                                                                        { label: "Drop", value: "Drop" },
                                                                        { label: "Pick & Drop", value: "Pick & Drop" },

                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                            {/* gender */}
                                                            <Form.Item
                                                                className="uploadCompany"
                                                                name="gender"
                                                                // initialValue={1}

                                                                label={
                                                                    <span>
                                                                        {this.context.translate("_GENDER_")}{" "}
                                                                        <span style={{ color: "red" }}>*</span>
                                                                    </span>
                                                                }
                                                                required={false}
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: `${this.context.translate(
                                                                            "_GENDER_"
                                                                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                                    },
                                                                ]}
                                                            >
                                                                <Select
                                                                    options={[
                                                                        { label: "Male", value: 1 },
                                                                        { label: "Female", value: 2 },
                                                                    ]}
                                                                />
                                                            </Form.Item>
                                                            {/* Student ID */}
                                                            <Form.Item
                                                                name="idNo"
                                                                className="uploadCompany"
                                                                required={false}
                                                                label={
                                                                    <span>
                                                                        {this.context.translate("_STUDENT_ID_")}{" "}
                                                                        <span style={{ color: "red" }}>*</span>
                                                                    </span>
                                                                }
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: `${this.context.translate(
                                                                            "_STUDENT_ID_"
                                                                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                                                                    },
                                                                ]}
                                                            >
                                                                <Input />
                                                            </Form.Item>

                                                        </Col>
                                                    </Row>
                                                </VehicleTitleBox>
                                            </div>
                                            <div className="formFooter">
                                                <Button
                                                    className="formsCancelButton"
                                                    onClick={() => {
                                                        this.closeModal();
                                                    }}
                                                >
                                                    {this.context.translate(
                                                        "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                                    )}
                                                </Button>
                                                <Button
                                                    onClick={(e) => {
                                                        this.handleNextClick();
                                                    }}
                                                    className="formsSaveButton"
                                                >
                                                    {this.context.translate("_NEXT_")}
                                                </Button>
                                            </div>
                                        </TabPane>



                                        <TabPane
                                            tab={
                                                <span
                                                    className={
                                                        this.state.tabErrors["2"] && "validation-failed"
                                                    }
                                                >
                                                    <Button
                                                        style={{
                                                            background:
                                                                this.state.activeTab === "2"
                                                                    ? " rgba(255, 255, 255, 0.30)"
                                                                    : "rgb(7, 22, 61)",
                                                            border: "none",
                                                            borderRadius: "0px",
                                                        }}
                                                        type=""
                                                    >
                                                        {this.context.translate(
                                                            "Pickup & Dropoff Details"
                                                        )}
                                                    </Button>
                                                </span>
                                            }
                                            key="2"
                                        >
                                            <div
                                                style={{
                                                    // overflowY: "scroll",
                                                    height: "90%",
                                                    paddingInlineStart: "20px",
                                                }}
                                            >

                                                <Row
                                                    style={{
                                                        overflowY: "scroll",
                                                        height: "90%",
                                                        paddingInlineStart: "20px",
                                                    }}
                                                >
                                                    <Col span={12} className="formColumnClass">
                                                        <VehicleTitleBox title={this.context.translate("_PICKUP_DETAILS_")}>

                                                            {/* <Form.Item label="Search Type" name="searchTypePick" initialValue="location">
                                                                <Select onChange={(val) => this.setState({ searchTypePick: val })}>
                                                                    <Select.Option value="location">Search by Location</Select.Option>
                                                                    <Select.Option value="coordinates">Search by Coordinates</Select.Option>
                                                                </Select>
                                                            </Form.Item> */}
                                                            <Form.Item name="pickupLat" label="Latitude">
                                                                <Input onBlur={this.handleLatLngChangePickup} />
                                                            </Form.Item>

                                                            <Form.Item name="pickupLng" label="Longitude">
                                                                <Input onBlur={this.handleLatLngChangePickup} />
                                                            </Form.Item>

                                                            {/* <Form.Item name="pickUpPoint" label="Pickup Address">
                                                                <Input onBlur={(e) => this.handleAddressChangePickup(e.target.value)} />
                                                            </Form.Item> */}

                                                            <Form.Item name="pickUpPoint" label="Pickup Address">
                                                                <Autocomplete
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "40px",
                                                                        padding: "4px 11px",
                                                                        border: "1px solid #d9d9d9",
                                                                        borderRadius: "6px"
                                                                    }}
                                                                    apiKey={config.googleMapKey}
                                                                    onPlaceSelected={this.handlePlaceSelectedpickup}
                                                                    componentRestrictions={{ country: "us" }}
                                                                    options={{
                                                                        types: ["geocode", "establishment"]
                                                                    }}
                                                                    placeholder="Enter pickup address"
                                                                />
                                                            </Form.Item>
                                                            {/* {this.state.searchTypePick === "location" ? (
                                                                <Form.Item
                                                                    className="uploadCompany"
                                                                    name="pickUpPoint"
                                                                    // label="Mark Location"
                                                                    label={this.context.translate("_PICKUP_POINT_")}
                                                                >
                                                                    <Autocomplete
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "40px",
                                                                            boxShadow: "none",
                                                                            padding: "4px 11px",
                                                                            borderWidth: 1,
                                                                            borderStyle: "solid",
                                                                            borderColor: "#d9d9d9",
                                                                            borderRadius: "6px",
                                                                        }}
                                                                        apiKey={config.googleMapKey}
                                                                        onPlaceSelected={this.handlePlaceSelectedpickup}
                                                                        componentRestrictions={{ country: "us" }}
                                                                        options={{
                                                                            types: ["geocode", "establishment"],
                                                                        }}
                                                                        placeholder={this.context.translate(
                                                                            "_PLEASE_ENTER_LOCATION_"
                                                                        )}
                                                                    />
                                                                </Form.Item>
                                                            ) : (
                                                                <Form.Item label="Enter Coordinates" className="uploadCompany" name="pickUpPoint">
                                                                    <Input
                                                                        placeholder="Latitude, Longitude (e.g. 19.9975, 73.7898)"
                                                                        value={this.state.coordinatesInputPick}
                                                                        onChange={(e) =>
                                                                            this.setState({ coordinatesInputPick: e.target.value })
                                                                        }
                                                                        onBlur={(e) =>

                                                                            this.handlePlaceSelectedpickupCoordinates(e.target.value)
                                                                        } />
                                                                </Form.Item>
                                                            )} */}

                                                            {/* pickUpPoint on map */}
                                                            <Form.Item label="Location Map">
                                                                <div style={{ height: "250px", width: "100%" }}>
                                                                    <DisplayLocationMap
                                                                        key={this.state.addressInfoPickup?.join(",")}
                                                                        addressInfo={this.state.addressInfoPickup || []}
                                                                        formRef={this.formRef}
                                                                        fieldName="pickUpPoint"
                                                                        // onLocationChange={(lat, lng) =>
                                                                        //     this.setState({ addressInfoPickup: [lat, lng] })
                                                                        // }
                                                                        onLocationChange={(lat, lng) => {
                                                                            this.setState({
                                                                                addressInfoPickup: [lat, lng],
                                                                                // dropoffLatLng: { lat, lng }
                                                                                pickupLatLng: { lat, lng }
                                                                            });

                                                                            // 🔥 THIS IS WHAT YOU WERE MISSING
                                                                            this.formRef.current.setFieldsValue({
                                                                                pickupLat: lat,
                                                                                pickupLng: lng
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>


                                                            </Form.Item>
                                                            {/* pickUpArea */}

                                                            <Form.Item
                                                                allowClear
                                                                name="pickUpArea"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_AREA_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Select
                                                                    allowClear
                                                                    showSearch
                                                                    name="pickUpArea"
                                                                    placeholder={this.context.translate("_SELECT_AREA_")}
                                                                    style={{ width: "100%" }}
                                                                    optionFilterProp="children"
                                                                >
                                                                    {this.state.arealist.map((val) => (
                                                                        <Option key={val.areaId} value={val.areaId}>
                                                                            {val.areaName}
                                                                        </Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>

                                                            {/* pickUpTrip */}
                                                            <Form.Item
                                                                name="pTripName"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_PICKUP_TRIP_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input disabled />
                                                            </Form.Item>
                                                            {/* pickupBus */}
                                                            <Form.Item

                                                                name="pickupBusId"
                                                                className="uploadCompany"
                                                                required={false}
                                                                label={
                                                                    <span>
                                                                        {this.context.translate("_PICKUP_BUSNO_")}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Select
                                                                    allowClear
                                                                    // placeholder="Select Asset"
                                                                    placeholder={this.context.translate(
                                                                        "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                                                                    )}
                                                                    showSearch

                                                                    optionFilterProp="children"
                                                                    filterOption={(inputValue, option) => {
                                                                        if (option.children) {
                                                                            return (
                                                                                option.children
                                                                                    .toLowerCase()
                                                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    {this.studentStore?.assetVehicleList?.map((val) => {
                                                                        return (
                                                                            <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </Form.Item>
                                                            {/* pickUpRoute */}
                                                            <Form.Item
                                                                name="pRouteName"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_PICKUP_ROUTE_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input disabled />
                                                            </Form.Item>


                                                        </VehicleTitleBox>
                                                    </Col>
                                                    <Col span={12} className="formColumnClass">
                                                        <VehicleTitleBox title={this.context.translate("_DROPOFF_DETAILS_")}>


                                                            {/* <Form.Item label="Search Type" name="searchTypeDrop" initialValue="location">
                                                                <Select onChange={(val) => this.setState({ searchTypeDrop: val })}>
                                                                    <Select.Option value="location">Search by Location</Select.Option>
                                                                    <Select.Option value="coordinates">Search by Coordinates</Select.Option>
                                                                </Select>
                                                            </Form.Item> */}

                                                            {/* {this.state.searchTypeDrop === "location" ? (
                                                                <Form.Item
                                                                    className="uploadCompany"
                                                                    name="dropPoint"
                                                                    // label="Mark Location"
                                                                    label={this.context.translate("_DROP_OFF_POINT_")}
                                                                >

                                                                    <Autocomplete
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "40px",
                                                                            boxShadow: "none",
                                                                            padding: "4px 11px",
                                                                            borderWidth: 1,
                                                                            borderStyle: "solid",
                                                                            borderColor: "#d9d9d9",
                                                                            borderRadius: "6px",
                                                                        }}
                                                                        apiKey={config.googleMapKey}
                                                                        onPlaceSelected={this.handlePlaceSelecteddropoff}
                                                                        componentRestrictions={{ country: "us" }}
                                                                        options={{
                                                                            types: ["geocode", "establishment"],
                                                                        }}
                                                                        placeholder={this.context.translate(
                                                                            "_PLEASE_ENTER_LOCATION_"
                                                                        )}
                                                                    />

                                                                </Form.Item>) :
                                                                (<Form.Item label="Enter Coordinates" className="uploadCompany" name="dropPoint">
                                                                    <Input
                                                                        placeholder="Latitude, Longitude (e.g. 19.9975, 73.7898)"
                                                                        value={this.state.coordinatesInputDrop}
                                                                        onChange={(e) =>
                                                                            this.setState({ coordinatesInputDrop: e.target.value })
                                                                        }
                                                                        onBlur={(e) =>

                                                                            this.handlePlaceSelecteddropCoordinates(e.target.value)
                                                                        } />
                                                                </Form.Item>)
                                                            } */}
                                                            {/* dropoffLat dropoffLng */}
                                                            <Form.Item name="dropoffLat" label="Latitude">
                                                                <Input onBlur={this.handleLatLngChangeDrop} />
                                                            </Form.Item>

                                                            <Form.Item name="dropoffLng" label="Longitude">
                                                                <Input onBlur={this.handleLatLngChangeDrop} />
                                                            </Form.Item>

                                                            {/* <Form.Item name="dropPoint" label="Drop Address">
                                                                <Input onBlur={(e) => this.handleAddressChangeDrop(e.target.value)} />
                                                            </Form.Item> */}
                                                            <Form.Item name="dropPoint" label="Drop Address">
                                                                <Autocomplete
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "40px",
                                                                        padding: "4px 11px",
                                                                        border: "1px solid #d9d9d9",
                                                                        borderRadius: "6px"
                                                                    }}
                                                                    apiKey={config.googleMapKey}
                                                                    onPlaceSelected={this.handlePlaceSelecteddropoff}
                                                                    componentRestrictions={{ country: "us" }}
                                                                    options={{
                                                                        types: ["geocode", "establishment"]
                                                                    }}
                                                                    placeholder="Enter drop address"
                                                                />
                                                            </Form.Item>
                                                            <Form.Item label="Location Map">
                                                                <div style={{ height: "250px", width: "100%" }}>
                                                                    <DisplayLocationMap
                                                                        key={this.state.addressInfoDropoff?.join(",")}
                                                                        addressInfo={this.state.addressInfoDropoff || []}
                                                                        formRef={this.formRef}
                                                                        fieldName="dropPoint"
                                                                        onLocationChange={(lat, lng) => {
                                                                            this.setState({
                                                                                addressInfoDropoff: [lat, lng],
                                                                                dropoffLatLng: { lat, lng }
                                                                            });

                                                                            // 🔥 THIS IS WHAT YOU WERE MISSING
                                                                            this.formRef.current.setFieldsValue({
                                                                                dropoffLat: lat,
                                                                                dropoffLng: lng
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>

                                                            </Form.Item>
                                                            {/* dropOffArea */}
                                                            <Form.Item
                                                                name="dropOffArea"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_AREA_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >

                                                                <Select
                                                                    name="dropOffArea"

                                                                    allowClear
                                                                    showSearch
                                                                    placeholder={this.context.translate("_SELECT_AREA_")}
                                                                    style={{ width: "100%" }}
                                                                    optionFilterProp="children"
                                                                >
                                                                    {this.state.arealist.map((val) => (
                                                                        <Option key={val.areaId} value={val.areaId}>
                                                                            {val.areaName}
                                                                        </Option>
                                                                    ))}
                                                                </Select>
                                                            </Form.Item>
                                                            {/* dropOffTrip */}
                                                            <Form.Item
                                                                name="dTripName"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_DROPOFF_TRIP_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input disabled />
                                                            </Form.Item>
                                                            {/* dropBus */}
                                                            <Form.Item

                                                                name="dropBusId"
                                                                className="uploadCompany"
                                                                required={false}
                                                                label={
                                                                    <span>
                                                                        {this.context.translate("_DROPOFF_BUSNO_")}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Select
                                                                    allowClear
                                                                    // placeholder="Select Asset"
                                                                    placeholder={this.context.translate(
                                                                        "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                                                                    )}
                                                                    showSearch

                                                                    optionFilterProp="children"
                                                                    filterOption={(inputValue, option) => {
                                                                        if (option.children) {
                                                                            return (
                                                                                option.children
                                                                                    .toLowerCase()
                                                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    {this.studentStore?.assetVehicleList?.map((val) => {
                                                                        return (
                                                                            <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </Form.Item>
                                                            {/* dropOffRoute */}
                                                            <Form.Item
                                                                name="dRouteName"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_DROPOFF_ROUTE_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input disabled />
                                                            </Form.Item>
                                                            {/* specialDropOffTrip */}
                                                            {/* <Form.Item
                                                                name="specialDropOffTrip"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_SPECIAL_DROPOFF_TRIP_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input />
                                                            </Form.Item> */}
                                                            {/* specialDropOffBus */}
                                                            {/* <Form.Item
                                                                name="specialDropOffBus"
                                                                className="uploadCompany"
                                                                required={false}
                                                                label={
                                                                    <span>
                                                                        {this.context.translate("_SPECIAL_DROPOFF_BUS_")}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Select
                                                                    // placeholder="Select Asset"
                                                                    placeholder={this.context.translate(
                                                                        "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                                                                    )}
                                                                    showSearch

                                                                    optionFilterProp="children"
                                                                    filterOption={(inputValue, option) => {
                                                                        if (option.children) {
                                                                            return (
                                                                                option.children
                                                                                    .toLowerCase()
                                                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    {this.studentStore?.assetVehicleList?.map((val) => {
                                                                        return (
                                                                            <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                                                                        );
                                                                    })}
                                                                </Select>
                                                            </Form.Item> */}
                                                        </VehicleTitleBox>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <div className="formFooter">
                                                <Button
                                                    className="formsCancelButton"
                                                    onClick={() => {
                                                        this.handleBackClick();
                                                    }}
                                                >
                                                    {this.context.translate(
                                                        "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                                                    )}
                                                </Button>
                                                <Button
                                                    onClick={(e) => {
                                                        this.handleNextClick();
                                                    }}
                                                    className="formsSaveButton"
                                                >
                                                    {this.context.translate("_NEXT_")}
                                                </Button>
                                            </div>
                                        </TabPane>



                                        <TabPane
                                            tab={
                                                <span
                                                    className={
                                                        this.state.tabErrors["3"] && "validation-failed"
                                                    }
                                                >
                                                    <Button
                                                        type=""
                                                        style={{
                                                            background:
                                                                this.state.activeTab === "3"
                                                                    ? " rgba(255, 255, 255, 0.30)"
                                                                    : "rgb(7, 22, 61)",
                                                            border: "none",
                                                            borderRadius: "0px",
                                                        }}
                                                    >
                                                        {this.context.translate("_CONTACT_DETAILS_")}
                                                    </Button>
                                                </span>
                                            }
                                            key="3"
                                        // style={{ marginLeft: "30px" }}
                                        >
                                            <div
                                                style={{
                                                    overflowY: "scroll",
                                                    height: "90%",
                                                    paddingInlineStart: "20px",
                                                }}
                                            >
                                                <VehicleTitleBox title={this.context.translate("")}>
                                                    <Row gutter={16}>
                                                        <Col span={12} className="formColumnClass">
                                                            {/* mobilenumber primary */}
                                                            <Form.Item
                                                                name="mobileNo"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_PRIMARY_CONTACT_NO_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                                rules={[
                                                                    {
                                                                        pattern: /^[0-9]*$/,
                                                                        message: "Only numbers are allowed",
                                                                    }
                                                                ]}
                                                            >
                                                                <Input onChange={(e) => {
                                                                    const value = e.target.value.replace(/\D/g, "");
                                                                    this.formRef?.current?.setFieldsValue({
                                                                        mobileNo: value,
                                                                    });
                                                                }} />
                                                            </Form.Item>


                                                        </Col>

                                                        <Col
                                                            span={12}
                                                            className="formColumnClass"
                                                            style={{ marginTop: "-3px" }}
                                                        >
                                                            {/* primary email id */}
                                                            <Form.Item
                                                                name="primaryEmail"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_PRIMARY_EMAILID_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </VehicleTitleBox>
                                                <VehicleTitleBox title={this.context.translate("_FATHER_DETAILS_")}>
                                                    <Row gutter={16}>
                                                        <Col span={12} className="formColumnClass">
                                                            {/* Father Contact details */}
                                                            <Form.Item
                                                                name="fatherName"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_FATHER_NAME_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                            <Form.Item
                                                                label={this.context.translate("_FATHER_CONTACT_NO_")}
                                                            >
                                                                <Space.Compact style={{ width: "100%" }}>
                                                                    <Form.Item
                                                                        name="fatherContactNoCountryCode"
                                                                        noStyle
                                                                        initialValue={config.countryCode}
                                                                    >
                                                                        <Select
                                                                            style={{ width: "55%", borderRadius: "5px" }}
                                                                            showSearch
                                                                            filterOption={(inputValue, option) => {
                                                                                if (option.children) {
                                                                                    return (
                                                                                        option.children
                                                                                            .toLowerCase()
                                                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                                                    );
                                                                                }
                                                                            }}
                                                                        >
                                                                            {this.countryStore?.country?.map((country) => {
                                                                                return (
                                                                                    <Option
                                                                                        value={parseInt(country.countryId)}
                                                                                        key={country.countryId}
                                                                                    >
                                                                                        {country.countryCode}
                                                                                    </Option>
                                                                                );
                                                                            })}
                                                                        </Select>
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        name="fatherContactNo"
                                                                        noStyle
                                                                        rules={[{
                                                                            pattern: /^[0-9]*$/,
                                                                            message: "Only numbers are allowed",
                                                                        },
                                                                        {
                                                                            pattern: /^\d{8,10}$/,
                                                                            // message: "Enter a 7 or 10 digit number",
                                                                            message: this.context.translate(
                                                                                "_Enter_7_or_10_Digit_Number_"
                                                                            ),
                                                                        },
                                                                        ]}
                                                                    >
                                                                        <Input
                                                                            style={{ width: "100%" }}
                                                                            onChange={(e) => {
                                                                                this.validateNumber(
                                                                                    e.target.value,
                                                                                    "fatherContactNo"
                                                                                );
                                                                            }}
                                                                        />
                                                                    </Form.Item>
                                                                </Space.Compact>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Form.Item
                                                                name="fatherWhatsAppNo"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_WHATSAPP_NO_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                                rules={[
                                                                    {
                                                                        pattern: /^[0-9]*$/,
                                                                        message: "Only numbers are allowed",
                                                                    },
                                                                    {
                                                                        pattern: /^\d{8,10}$/,
                                                                        // message: "Enter a 7 or 10 digit number",
                                                                        message: this.context.translate(
                                                                            "_Enter_7_or_10_Digit_Number_"
                                                                        ),
                                                                    },
                                                                ]}
                                                            >
                                                                <Input onChange={(e) => {
                                                                    this.validateNumber(
                                                                        e.target.value,
                                                                        "fatherWhatsAppNo"
                                                                    );
                                                                }} />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name="fatherEmail"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_EMAIL_ID_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </VehicleTitleBox>
                                                <VehicleTitleBox title={this.context.translate("_MOTHER_DETAILS_")}>
                                                    <Row gutter={16}>
                                                        <Col span={12} className="formColumnClass">
                                                            {/* Father Contact details */}
                                                            <Form.Item
                                                                name="motherName"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_MOTHER_NAME_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                            <Form.Item
                                                                label={this.context.translate("_MOTHER_CONTACT_NO_")}
                                                            >
                                                                <Space.Compact style={{ width: "100%" }}>
                                                                    <Form.Item
                                                                        name="motherContactNoCountryCode"
                                                                        noStyle
                                                                        initialValue={config.countryCode}
                                                                    >
                                                                        <Select
                                                                            style={{ width: "55%", borderRadius: "5px" }}
                                                                            showSearch
                                                                            filterOption={(inputValue, option) => {
                                                                                if (option.children) {
                                                                                    return (
                                                                                        option.children
                                                                                            .toLowerCase()
                                                                                            .indexOf(inputValue.toLowerCase()) >= 0
                                                                                    );
                                                                                }
                                                                            }}
                                                                        >
                                                                            {this.countryStore?.country?.map((country) => {
                                                                                return (
                                                                                    <Option
                                                                                        value={parseInt(country.countryId)}
                                                                                        key={country.countryId}
                                                                                    >
                                                                                        {country.countryCode}
                                                                                    </Option>
                                                                                );
                                                                            })}
                                                                        </Select>
                                                                    </Form.Item>
                                                                    <Form.Item
                                                                        name="motherContactNo"
                                                                        noStyle
                                                                        rules={[
                                                                            {
                                                                                pattern: /^\d{8,10}$/,
                                                                                // message: "Enter a 7 or 10 digit number",
                                                                                message: this.context.translate(
                                                                                    "_Enter_7_or_10_Digit_Number_"
                                                                                ),
                                                                            },
                                                                            {
                                                                                pattern: /^[0-9]*$/,
                                                                                message: "Only numbers are allowed",
                                                                            },
                                                                        ]}
                                                                    >
                                                                        <Input
                                                                            style={{ width: "100%" }}
                                                                            onChange={(e) => {
                                                                                this.validateNumber(
                                                                                    e.target.value,
                                                                                    "motherContactNo"
                                                                                );
                                                                            }}
                                                                        />
                                                                    </Form.Item>
                                                                </Space.Compact>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Form.Item
                                                                name="motherWhatsAppNo"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_WHATSAPP_NO_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                                rules={[
                                                                    {
                                                                        pattern: /^\d{8,10}$/,
                                                                        // message: "Enter a 7 or 10 digit number",
                                                                        message: this.context.translate(
                                                                            "_Enter_7_or_10_Digit_Number_"
                                                                        ),
                                                                    },
                                                                    {
                                                                        pattern: /^[0-9]*$/,
                                                                        message: "Only numbers are allowed",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input onChange={(e) => {
                                                                    this.validateNumber(
                                                                        e.target.value,
                                                                        "motherWhatsAppNo"
                                                                    );
                                                                }} />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name="motherEmail"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_EMAIL_ID_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </VehicleTitleBox>
                                                <VehicleTitleBox title={this.context.translate("_GUARDIAN_DETAILS_")}>
                                                    <Row gutter={16}>
                                                        <Col span={12} className="formColumnClass">
                                                            {/* /* Guardian Contact details */}
                                                            <Form.Item
                                                                name="guardianName"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_GUARDIAN_NAME_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name="guardianContactNo"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_CONTACT_NO_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                                rules={[
                                                                    {
                                                                        pattern: /^\d{8,10}$/,
                                                                        // message: "Enter a 7 or 10 digit number",
                                                                        message: this.context.translate(
                                                                            "_Enter_7_or_10_Digit_Number_"
                                                                        ),
                                                                    },
                                                                    {
                                                                        pattern: /^[0-9]*$/,
                                                                        message: "Only numbers are allowed",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input onChange={(e) => {
                                                                    this.validateNumber(
                                                                        e.target.value,
                                                                        "guardianContactNo"
                                                                    );
                                                                }} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={12}>
                                                            <Form.Item
                                                                name="gardianWhatsAppNo"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_WHATSAPP_NO_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                                rules={[
                                                                    {
                                                                        pattern: /^\d{8,10}$/,
                                                                        // message: "Enter a 7 or 10 digit number",
                                                                        message: this.context.translate(
                                                                            "_Enter_7_or_10_Digit_Number_"
                                                                        ),
                                                                    },
                                                                    {
                                                                        pattern: /^[0-9]*$/,
                                                                        message: "Only numbers are allowed",
                                                                    },
                                                                ]}
                                                            >
                                                                <Input onChange={(e) => {
                                                                    this.validateNumber(
                                                                        e.target.value,
                                                                        "gardianWhatsAppNo"
                                                                    );
                                                                }} />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name="gardianEmail"
                                                                className="uploadCompany"
                                                                label={
                                                                    <span>
                                                                        {this.context.translate(
                                                                            "_EMAIL_ID_"
                                                                        )}{" "}
                                                                    </span>
                                                                }
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </VehicleTitleBox>
                                                <VehicleTitleBox title={this.context.translate("_UPLOAD_PHOTO_")}>
                                                    <Row>
                                                        <Col span={8} className="formColumnClass">
                                                            <Form.Item
                                                                name="photo"
                                                                label={this.context.translate("_UPLOAD_STUDENT_PHOTO_")}
                                                                className="formCheckboxCss"
                                                                required={false}
                                                                getValueFromEvent={this.normFile}

                                                            >
                                                                <Upload
                                                                    name="studentphoto"
                                                                    listType="picture"
                                                                    customRequest={(options) =>
                                                                        this.uploadFunctionimg(options)
                                                                    }
                                                                    onChange={(info) => this.getUploadData(info, "studentphoto")}
                                                                    // onChange={ = ("studentphoto") => { }}
                                                                    onRemove={async () => {
                                                                        await this.studentStore.setPhotoFromDbstud([]);
                                                                        await this.setState({ photo: "", fileList: [] });
                                                                    }}
                                                                    maxCount={1}
                                                                    accept=".jpg,.jpeg,.png"
                                                                    beforeUpload={(file) => this.validateFile(file)}
                                                                    {...this.studentStore.photoFromDb}
                                                                >
                                                                    <Button className="imgupload" icon={<UploadOutlined />}>
                                                                        {this.context.translate(
                                                                            "_FLEET_DASHBORD_NEWPOI_PHOTO_"
                                                                        )}
                                                                    </Button>
                                                                </Upload>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8} className="formColumnClass">
                                                            <Form.Item
                                                                name="photo"
                                                                label={this.context.translate("_UPLOAD_PARENT_PHOTO_1_")}
                                                                className="formCheckboxCss"
                                                                required={false}
                                                                getValueFromEvent={this.normFile}

                                                            >
                                                                <Upload
                                                                    name="parentphoto1"
                                                                    listType="picture"
                                                                    customRequest={(options) =>
                                                                        this.uploadFunctionimg(options)
                                                                    }
                                                                    onChange={(info) => this.getUploadData(info, "parentphoto1")}
                                                                    // onChange={ = ("studentphoto") => { }}
                                                                    onRemove={async () => {
                                                                        await this.studentStore.setPhotoFromDbparent1([]);
                                                                        await this.setState({ photo1: "", fileList: [] });
                                                                    }}
                                                                    maxCount={1}
                                                                    accept=".jpg,.jpeg,.png"
                                                                    beforeUpload={(file) => this.validateFile(file)}
                                                                    {...this.studentStore.photoFromDbparent1}
                                                                >
                                                                    <Button className="imgupload" icon={<UploadOutlined />}>
                                                                        {this.context.translate(
                                                                            "_FLEET_DASHBORD_NEWPOI_PHOTO_"
                                                                        )}
                                                                    </Button>
                                                                </Upload>
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8} className="formColumnClass">
                                                            <Form.Item
                                                                name="photo"
                                                                label={this.context.translate("_UPLOAD_PARENT_PHOTO_1_")}
                                                                className="formCheckboxCss"
                                                                required={false}
                                                                getValueFromEvent={this.normFile}

                                                            >
                                                                <Upload
                                                                    name="parentphoto2"
                                                                    listType="picture"
                                                                    customRequest={(options) =>
                                                                        this.uploadFunctionimg(options)
                                                                    }
                                                                    onChange={(info) => this.getUploadData(info, "parentphoto2")}
                                                                    // onChange={ = ("studentphoto") => { }}
                                                                    onRemove={async () => {
                                                                        await this.studentStore.setPhotoFromDbparent2([]);
                                                                        await this.setState({ photo2: "", fileList: [] });
                                                                    }}
                                                                    maxCount={1}
                                                                    accept=".jpg,.jpeg,.png"
                                                                    beforeUpload={(file) => this.validateFile(file)}
                                                                    {...this.studentStore.photoFromDbparent2}
                                                                >
                                                                    <Button className="imgupload" icon={<UploadOutlined />}>
                                                                        {this.context.translate(
                                                                            "_FLEET_DASHBORD_NEWPOI_PHOTO_"
                                                                        )}
                                                                    </Button>
                                                                </Upload>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>

                                                </VehicleTitleBox>

                                            </div>

                                            <div className="formFooter">
                                                <Button
                                                    className="formsCancelButton"
                                                    onClick={() => {
                                                        this.handleBackClick();
                                                    }}
                                                >
                                                    {this.context.translate(
                                                        "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                                                    )}
                                                </Button>
                                                <Button
                                                    // onClick={(e) => {
                                                    //     this.handleNextClick();
                                                    // }}
                                                    htmlType="submit"
                                                    className="formsSaveButton"
                                                >
                                                    {this.context.translate("_SUBMIT_")}
                                                </Button>
                                            </div>
                                        </TabPane>
                                    </Tabs>
                                </div>
                            </Form>
                        </Spin>
                    </div>


                </div >
                {
                    this.state.addressMapPickup && (
                        <Modal
                            className="multiTracking-popup"
                            style={{ padding: "0px !important" }}
                            title={
                                <div>
                                    Location On Map (Pick Up Address)
                                    <CloseOutlined
                                        onClick={() => this.setState({ addressMapPickup: false })}
                                    />
                                </div>
                            }
                            maskClosable={false}
                            centered
                            bodyStyle={{ height: "60vh", padding: "0px" }} // Adjust the dimensions as needed
                            width={1000}
                            visible={this.state.addressMapPickup}
                            onCancel={() => this.setState({ addressMapPickup: false })}
                            footer={null}
                        >

                            <DisplayLocationMap
                                addressInfo={this.state.addressInfoPickup || []}
                                formRef={this.formRef}
                                fieldName="pickUpPoint"
                                onLocationChange={(lat, lng) => {
                                    this.setState({
                                        addressInfoPickup: [lat, lng],
                                        // dropoffLatLng: { lat, lng }
                                        pickupLatLng: { lat, lng }
                                    });

                                    this.formRef.current.setFieldsValue({
                                        pickupLat: lat,
                                        pickupLng: lng
                                    });
                                }}
                            />
                        </Modal>
                    )
                }


                {
                    this.state.addressMapDropoff && (
                        <Modal
                            className="multiTracking-popup"
                            style={{ padding: "0px !important" }}
                            title={
                                <div>
                                    Location On Map (Drop Off Address)
                                    <CloseOutlined
                                        onClick={() => this.setState({ addressMapDropoff: false })}
                                    />
                                </div>
                            }
                            maskClosable={false}
                            centered
                            bodyStyle={{ height: "60vh", padding: "0px" }} // Adjust the dimensions as needed
                            width={1000}
                            visible={this.state.addressMapDropoff}
                            onCancel={() => this.setState({ addressMapDropoff: false })}
                            footer={null}
                        >

                            <DisplayLocationMap
                                addressInfo={this.state.addressInfoDropoff || []}
                                formRef={this.formRef}
                                fieldName="dropPoint"
                                onLocationChange={(lat, lng) => {
                                    this.setState({
                                        addressInfoDropoff: [lat, lng],
                                        dropoffLatLng: { lat, lng }
                                    });

                                    // 🔥 THIS IS WHAT YOU WERE MISSING
                                    this.formRef.current.setFieldsValue({
                                        dropoffLat: lat,
                                        dropoffLng: lng
                                    });
                                }}
                            />

                        </Modal>
                    )
                }


            </>
        );
    }
}
StudentAdd.contextType = StoreContext;
export default observer(withRouter1(StudentAdd));
